import type { OfferAdditionalCompensationToggle } from '../types';

export const OFFER_ADDITIONAL_COMPENSATION_YES: OfferAdditionalCompensationToggle = 'yes';
export const OFFER_ADDITIONAL_COMPENSATION_NO: OfferAdditionalCompensationToggle = 'no';
